<template>
  <b-form id="edit-max-cam-modal" @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>{{ $t("maxCamEnabled") }} <span class="text-danger">*</span></template>
      <b-form-input type="number" v-model="maxCam" required min="0"></b-form-input>
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{
        $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("save") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped></style>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseComponent from "@/components/BaseComponent";
import * as meetingService from "@/service/meetingService";

@Component
export default class EditMaxCamModal extends BaseComponent {

  @Prop({ required: true }) modalId: string;
  @Prop({ required: true }) meetingId: number;

  @Prop({ default: 0 }) maxCamValue: number;

  @Emit("submitted") __submitted() { }


  maxCam: number = 0;


  // Lắng nghe thay đổi khi bấm vào các meeting khác nhau
  @Watch('maxCamValue', { immediate: true })
  onMaxCamChange(val: number) {
    this.maxCam = val || 0;
  }

  formErrorMsg = "";
  isSubmitting = false;




  onClickCancel() {
    this.$bvModal.hide(this.modalId);
  }


  async submitForm() {
    this.formErrorMsg = "";
    try {
      this.isSubmitting = true;
      await meetingService.updateConfigMeeting(this.meetingId, this.maxCam);

      this.__submitted();
      this.toastSuccessDelay(this.$t("updateMaxCamSuccess").toString());
      this.$bvModal.hide(this.modalId);

    } catch (e) {
      this.toastError(e);

    } finally {
      this.isSubmitting = false;
    }
  }

}
</script>
